import { render, staticRenderFns } from "./FinalizacaoCertidoes.vue?vue&type=template&id=8534a6e0"
import script from "./FinalizacaoCertidoes.vue?vue&type=script&lang=js"
export * from "./FinalizacaoCertidoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports